import { styled, useMediaQuery, useTheme } from '@mui/material';

import {
  CrewAvailabilityBoard,
  WidgetCrewAvailabilityContent,
} from '#features';

import { Widget } from '../base';

import type { WidgetConfigBase, WidgetProps } from '#features';

type Settings = {
  maxRows?: number;
} & Record<string, unknown>;

const config: WidgetConfigBase<Settings> = {
  maxRows: {
    type: 'number',
    label: 'Max Rows',
    defaultValue: 0,
    min: 0,
    step: 1,
  },
};

export interface WidgetCrewAvailabilityExternalProps {
  fullSize?: boolean;
  showSettingsButton?: boolean;
  className?: string;
}

const Root = styled(Widget)(() => ({
  position: 'relative',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  maxHeight: '100%',
}));

export const WidgetCrewAvailability = ({
  instance,
  showSettingsButton,
  className,
  ...defaults
}: WidgetProps<Settings> & WidgetCrewAvailabilityExternalProps) => {
  const theme = useTheme();
  const isEnoughHeight = useMediaQuery('(min-height:850px)');
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const fullSize = defaults.fullSize ?? false;
  const shouldRenderVertically = fullSize && isMobile;
  const renderFullSize = (fullSize && isEnoughHeight) || shouldRenderVertically;

  return (
    <Root
      config={config}
      instance={instance}
      className={className}
      showSettingsButton={!renderFullSize && (showSettingsButton ?? true)}
    >
      {settings =>
        renderFullSize ? (
          <CrewAvailabilityBoard once={shouldRenderVertically} />
        ) : (
          <WidgetCrewAvailabilityContent {...(settings as Settings)} />
        )
      }
    </Root>
  );
};
WidgetCrewAvailability.config = config;
